import React from 'react';

import Change from '../../components/Auth/Change';

const ChangePassword = () => (
  <Change />
);

export default ChangePassword;